import { LitElement } from '@lit'

class NovaCustomerService extends LitElement {
  constructor() {
    super()
    this._onClick = this._onClick.bind(this)
    this._onResize = this._onResize.bind(this)

    this._desktopButtons = []
    this._contentSections = []
  }

  connectedCallback() {
    super.connectedCallback()

    this._desktopButtons = [...this.querySelectorAll('[data-element="js-cs-button-dt"]')]
    this._contentSections = [...this.querySelectorAll('[data-element="js-cs-content"]')]

    this.addEventListener('click', this._onClick)
    window.addEventListener('resize', this._onResize)

    this._setDefaultDesktopTab()

    document.addEventListener("DOMContentLoaded", function() {
      const targetEl = this.querySelector(location.hash)
      if (!targetEl) return
      const buttonEl = this.querySelector(`[data-target="${location.hash}"]`)
      if(!buttonEl) return
      buttonEl.click()

      requestAnimationFrame(() => {
        const y = targetEl.getBoundingClientRect().top + window.pageYOffset - 120
        window.scrollTo({ top: y, behavior: 'smooth' })
      })
    })
  }

  disconnectedCallback() {
    this.removeEventListener('click', this._onClick)
    window.removeEventListener('resize', this._onResize)
    super.disconnectedCallback()
  }

  _onClick(e) {
    if (window.innerWidth < 990) {
      this._handleMobileClick(e)
    } else {
      this._handleDesktopClick(e)
    }
  }

  _getSafeHeaderHeight() {
    const h = Number(window.headerHeight)
    return isNaN(h) ? 0 : h
  }

  _handleMobileClick(e) {
    const button = e.target.closest('[data-element="js-cs-button-mb"]')
    if (!button || !button.dataset.target) return

    const targetSelector = button.dataset.target
    const targetEl = this.querySelector(targetSelector)
    if (!targetEl) return

    const y = targetEl.getBoundingClientRect().top + window.pageYOffset - this._getSafeHeaderHeight()
    window.scrollTo({ top: y, behavior: 'smooth' })
  }

  _handleDesktopClick(e) {
    const button = e.target.closest('[data-element="js-cs-button-dt"]')
    if (!button || !button.dataset.target) return

    const targetSelector = button.dataset.target
    const targetContent = this.querySelector(targetSelector)
    if (!targetContent) return

    this._updateSelection(this._desktopButtons, button)
    this._updateSelection(this._contentSections, targetContent)
  }

  _onResize() {
    if (window.innerWidth >= 990) {
      this._setDefaultDesktopTab()
    }
  }

  _setDefaultDesktopTab() {
    if (this._desktopButtons.length && this._contentSections.length) {
      this._updateSelection(this._desktopButtons, this._desktopButtons[0])
      this._updateSelection(this._contentSections, this._contentSections[0])
    }
  }

  _updateSelection(elements, selectedElement) {
    elements.forEach(el => el.setAttribute('data-selected', 'false'))
    selectedElement.setAttribute('data-selected', 'true')
  }

  createRenderRoot() {
    return this
  }
}

customElements.define('nova-customer-service', NovaCustomerService)

